/** In-memory cache so navbar routes feel instant when revisited in the same tab session. */
const store = new Map();

export const routeSessionCache = {
  getData(key) {
    const entry = store.get(key);
    return entry ? entry.data : null;
  },

  set(key, data) {
    store.set(key, { data, at: Date.now() });
  },

  invalidate(key) {
    store.delete(key);
  },

  invalidatePrefix(prefix) {
    for (const key of store.keys()) {
      if (key.startsWith(prefix)) store.delete(key);
    }
  },

  clearAll() {
    store.clear();
  }
};
